// Spacing / sizing tokens shared across the app.

export const PAGE_PADDING = 15; // px
export const CARD_BORDER_RADIUS = 20; // px
export const MOBILE_BREAKPOINT = "md" as const; // theme.breakpoints.down(MOBILE_BREAKPOINT)
export const SMALL_PHONE_WIDTH = 360; // px
export const DIALOG_PADDING = 10; // px
export const DIALOG_RADIUS_SM = 8; // px — the original's small dialog radius

export const APPBAR_HEIGHT = 60;
/** Side-panel width between `lg` and `xxl` (the original's `pG`). */
export const DRAWER_WIDTH_MD = 360;
/** Modal surface width below the desktop cap (the original's `iF`). */
export const MODAL_WIDTH = "95vw";
/** Backdrop/fade duration used by every overlay (the original's `Ve`). */
export const OVERLAY_TRANSITION_MS = 200;
export const BUTTON_HEIGHT_LARGE = 50;
export const BUTTON_HEIGHT_MEDIUM = 40;
export const BUTTON_HEIGHT_SMALL = 30;

export const FONT_WEIGHT_REGULAR = 400;
export const FONT_WEIGHT_MEDIUM = 500;
export const FONT_WEIGHT_BOLD = 700;

export const BREAKPOINT_VALUES: Record<string, number> = {
  xxs: 0,
  xs: 450,
  sm: 650,
  md: 800,
  lg: 900,
  xl: 1100,
  xxl: 1200,
  xxxl: 1530,
};

/**
 * Horizontal gutters the menu page grows as the window does. Verbatim from the
 * original bundle: `lg` keeps the 15px page padding, then it switches to
 * percentages so the grid does not stretch edge-to-edge on very wide screens.
 */
export const CONTENT_GUTTER = {
  lg: `${PAGE_PADDING}px`,
  xl: "5%",
  xxl: "7%",
  xxxl: "7%",
} as const;

/**
 * The MODERN gutter set. `settings.web_design_type` starting with `MODERN`
 * swaps `a.pd`/`a.C4` for `a.K1`/`a.Kn` at the top two breakpoints — which is a
 * difference of exactly ONE value: `xxxl` widens from 7% to **12%**. Every
 * other step is identical, which is why the two maps look nearly the same.
 *
 * ⚠ The tab strip (`t4`) and its skeleton (`ne`) are the documented exception:
 * both use the non-modern values unconditionally.
 */
export const CONTENT_GUTTER_MODERN = {
  lg: `${PAGE_PADDING}px`,
  xl: "5%",
  xxl: "7%",
  xxxl: "12%",
} as const;

/** `l.VT` — the Slate navbar's height, against `APPBAR_HEIGHT`'s 60. */
export const SLATE_APPBAR_HEIGHT = 100;

/** Pick the gutter map a surface should use for a given design type. */
export const gutterFor = (isModernDesign?: boolean) =>
  isModernDesign ? CONTENT_GUTTER_MODERN : CONTENT_GUTTER;

/**
 * Every back/close Fab in the original carries `name="BACK_BUTTON_NAME"`, and a
 * global `popstate` listener clicks the LAST one so the browser's back button
 * closes the topmost overlay instead of leaving the page (module 7302 `wl`).
 * The order bar carries the same name but is skipped whenever anything else is
 * on screen — hence the second constant (module 7302 `DU`).
 */
export const BACK_BUTTON_NAME = "BACK_BUTTON_NAME";
export const ORDER_BAR_ID = "ORDER_BAR";
/** Only the first three overlay pushes get a `pushState` (`HASHED_TIMES`). */
export const MAX_HASHED_TIMES = 3;
/** Height of the scrollable tab strip inside the Store Hours screen (`O.rq`). */
export const SCROLLABLE_TABS_HEIGHT = 35;
/**
 * The original's faux-bold: a zero-width text stroke (`O.ZY`) applied alongside
 * a weight bump so the emphasised row reads slightly heavier without swapping
 * font files. Verbatim — it really is `0px`.
 */
export const TEXT_STROKE = "0px #d3d3d3";

/**
 * `sm` in module 7302 — the longitude nudge every Mapbox GeoJSON route line in
 * the platform is drawn with: `[lng + sm, lat]`. The bundle resolves it to
 * `-0.00004` (roughly 4 m west at the equator), and it is applied to the route
 * geometry only, never to the markers, so the line sits just off the kerb the
 * pins stand on rather than running underneath them. The POS carries the same
 * value.
 */
export const MAP_LONGITUDE_OFFSET = -0.00004;

export const SHAPE = {
  borderRadius: 8,
  borderRadiusSm: 12,
  borderRadiusMd: 16,
};
